"use strict";

exports.__esModule = true;
exports.default = CardDivider;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

var _styled = require("./styled");

var _propTypes = require("./propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function CardDivider(props) {
  return (0, _core.jsx)(_styled.CardDividerRoot, _extends({}, props, {
    role: "separator"
  }));
}

CardDivider.displayName = 'CardDivider';
CardDivider.propTypes = process.env.NODE_ENV !== "production" ? _propTypes.cardDividerPropTypes : {};